module.exports = __webpack_public_path__ + "static/media/maximize.08e605b2.svg";